export default __webpack_public_path__ + "static/media/icons8-social-64.dc2e2403.svg";